import { createSelector } from '@reduxjs/toolkit';

import { PlateType } from '@paragon/contract-library/lib/designService';
import { isG2User } from '@paragon/login-tools';
import { getPlateTypeString } from '@paragon/material-lists';

export const getPlateTypeFormatter = createSelector(
  isG2User,
  (isG2User) => (plateType: PlateType, tangiblePlateTypesForComboPlateType: readonly PlateType[]) => {
    const plateTypeString = getPlateTypeString(plateType, tangiblePlateTypesForComboPlateType);
    return isG2User ? plateTypeString.replace('CH', 'G2') : plateTypeString;
  },
);

export const getPlateManufacturerFormatter = createSelector(
  isG2User,
  (isG2User) => (plateManufacturer: string) =>
    isG2User ? plateManufacturer.replace('CH Machine', 'G2') : plateManufacturer,
);
